<script>
  import DisplayContainer from 'src/pc/components/DisplayContainer'
  export default {
    extends: DisplayContainer,
    computed: {
      getAccess () {
        return 'mobile'
      },
      getAdViewUrl () {
        return 'https://teralog.techhub.co.kr/imp?la_gc=TR8703006127&la_src=ib&la_cnfg='  // 테라 실계정 Mobile
        // return 'https://teralog.techhub.co.kr/imp?la_gc=TR8703005279&la_src=ib&la_cnfg='  // 테라 테스트계정 Mobile
      },
      isActiveComponent () {
        // console.log(this.section, this.getRootComponentName)
        const rtn =
          (
            this.getRootComponentName === 'DefaultLayout'
            || this.getRootComponentName === 'SubPageLayout'
            || this.getRootComponentName === 'PageLayout'
            || this.getRootComponentName === undefined
            || this.getRootComponentName === this.getRouteName
          )
        return rtn
      }
    }
  }
</script>

<style>
 .display-container a > img {
   max-width: unset !important;
   height: auto !important;
	 width: 100% !important;
 }
 .display-container .q-carousel {
   background-color: transparent !important;
 }
</style>
